import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export default ({ value, onChange }) => (
  <FormGroup className="mb-2">
    <Label htmlFor="sortDirection" className="mb-1">
      Direction:
    </Label>
    <Input
      type="select"
      id="sortDirection"
      value={value}
      onChange={e => onChange(e.target.value)}
    >
      <option value="ASC">Ascending</option>
      <option value="DESC">Descending</option>
    </Input>
  </FormGroup>
);
